import { version } from '../../package.json';

/**
 * Версия платформы — из своего `package.json`, а не строкой в словаре.
 *
 * В словаре она и стояла, целиком: `v0.1.0 · фаза {{phase}}`. Номер там
 * держится ровно до первого выпуска — подписи переводят, а не сверяют
 * с манифестом, — и оболочка полгода показывала 0.1.0 при выпущенной 0.2.0.
 * Хуже того, номеров было два, по одному на язык, и разойтись они могли
 * между собой: проверка словарей сличает ключи и подстановки, а не значения.
 *
 * По этой подписи сверяют, доехало ли обновление, — тот же довод, по которому
 * api читает свою версию из манифеста, а не из зашитой строки. Номер один
 * на весь репозиторий: `chore: версия платформы` поднимает его во всех
 * манифестах разом, включая этот.
 *
 * Собирается в бандл значением, а не файлом: `import { version }` — именованный
 * импорт, и остальное содержимое манифеста (список зависимостей с версиями)
 * до браузера не доезжает.
 */
export const APP_VERSION: string = version;
